(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-article-flyrank"]) return;
  try {
    
  function moveArticleFeaturedCollection() {
    const featuredCollection = document.querySelector('.article-featured-collection');
    const rte = document.querySelector('.article-body .rte');

    if (!featuredCollection || !rte) return;

    const headings = [...rte.querySelectorAll('h2')].filter(
      (heading) => !heading.closest('.article-featured-collection')
    );
    const targetHeading = headings[3];

    if (targetHeading) {
      targetHeading.parentNode.insertBefore(featuredCollection, targetHeading);
    }

    featuredCollection.classList.remove('article-featured-collection--pending');

    const swiperEl = featuredCollection.querySelector('.article-featured-collection-slider');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.update();
    }
  }

  window.addEventListener('load', moveArticleFeaturedCollection);

  } catch(e) { console.error(e); }
})();
})();
